import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { ACQUISITION_DETAIL_BIDDABLE_LIST, ACQUISITION_DETAIL_BIDDABLE_ADD, ACQUISITION_DETAIL_BIDDABLE_UPDATE } from '../../actions';
import {
  AcquisitionDetailBiddableListSuccess, AcquisitionDetailBiddableListError,
  AcquisitionDetailBiddableAddSuccess, AcquisitionDetailBiddableAddError,
  AcquisitionDetailBiddableUpdateSuccess, AcquisitionDetailBiddableUpdateError
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition/acquisition_detail/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition/acquisition_detail/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'acquisition/acquisition_detail/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onList(data) {
  try {
    const response = yield call(onListAsync, data.payload);
    yield put(AcquisitionDetailBiddableListSuccess(response.data));
  } catch (error) { yield put(AcquisitionDetailBiddableListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Éxito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(AcquisitionDetailBiddableAddSuccess(response.data));
  } catch (error) { yield put(AcquisitionDetailBiddableAddError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Éxito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(AcquisitionDetailBiddableUpdateSuccess(response.data));
  } catch (error) { yield put(AcquisitionDetailBiddableUpdateError(error)); }
}

export function* watchList() { yield takeEvery(ACQUISITION_DETAIL_BIDDABLE_LIST, onList); }
export function* watchAdd() { yield takeEvery(ACQUISITION_DETAIL_BIDDABLE_ADD, onAdd); }
export function* watchUpdate() { yield takeEvery(ACQUISITION_DETAIL_BIDDABLE_UPDATE, onUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchUpdate)]);
}
